import {Stack} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {UnitCard} from 'presentation/modules/booking/shared/ui/components/UnitCard';
import {EmptySelfNetworkAlert} from 'presentation/modules/booking/shared/ui/components/EmptySelfNetworkAlert';
import {UnitNetworkHeader} from 'presentation/modules/booking/shared/ui/components/UnitNetworkHeader';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useOdontoUnitsSelfNetwork} from './hooks/useOdontoUnitsSelfNetwork';
import {OdontoUnitsSelfNetworkProps} from './types';
import {StyledButton} from './styles';

const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function OdontoUnitsSelfNetwork({handleNextStep, unitsList}: OdontoUnitsSelfNetworkProps) {
	const {
		handleSelectCard,
		query,
		isMobile,
		specialtyName,
		shouldShowDistanceReference,
		filterIsActive,
		handleOpenDrawer,
		openDrawerButtonLabel,
		shouldHideDrawerButton,
		showEmptyAlert,
		getEmptyAlertDescription,
	} = useOdontoUnitsSelfNetwork({
		handleNextStep,
		unitsList,
	});

	return (
		<Stack gap={2}>
			{showEmptyAlert ? (
				<EmptySelfNetworkAlert description={getEmptyAlertDescription()} />
			) : (
				<UnitNetworkHeader
					title={selfNetwork.title}
					description={selfNetwork.onlineScheduleDescription}
				/>
			)}

			<Grid container spacing={2}>
				{unitsList.units.unitsByLocality.map((unit, index) => {
					return (
						<Grid
							key={`${unit.name}-${unit.formattedAddress}${index}`}
							size={{xs: isMobile ? 12 : 6}}>
							<UnitCard
								query={query}
								isNotSelf={false}
								onClick={() =>
									handleSelectCard({
										district: unit?.district,
										code: unit?.code,
										address: unit?.formattedAddress,
										name: unit?.name,
									})
								}
								unitName={unit?.name}
								address={unit?.formattedAddress}
								isTelemedicine={false}
								distanceReference={unit?.distance}
								showDistanceReference={shouldShowDistanceReference}
								specialtyName={specialtyName}
							/>
						</Grid>
					);
				})}
			</Grid>

			{shouldHideDrawerButton ? null : (
				<StyledButton
					data-tag-id={
						filterIsActive
							? AppointmentBookingEnum.ALTEROU_DISTANCIA
							: AppointmentBookingEnum.PROCUROU_UNIDADES_PROXIMAS
					}
					variant="outlined"
					size="large"
					onClick={handleOpenDrawer}>
					{openDrawerButtonLabel()}
				</StyledButton>
			)}
		</Stack>
	);
}
